import {BuilderArea} from "../enums/builder-area";

function loadView(view) {
  return () => import(`../components/view-${view}.vue`);
}

const routes = [
  {
    name: BuilderArea.layout,
    path: '/layout',
    component: loadView('layout'),
  },
  {
    name: BuilderArea.filters,
    path: '/filters',
    component: loadView('filters'),
  },
  {
    name: BuilderArea.settings,
    path: '/settings',
    component: loadView('settings'),
  },
  {
    name: 'null',
    path: '/',
    redirect: {name: BuilderArea.layout},
  }
];

export default routes;